import { render, staticRenderFns } from "./BrandTabs.vue?vue&type=template&id=0315d95b&scoped=true&"
import script from "./BrandTabs.vue?vue&type=script&lang=js&"
export * from "./BrandTabs.vue?vue&type=script&lang=js&"
import style0 from "./BrandTabs.vue?vue&type=style&index=0&id=0315d95b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315d95b",
  null
  
)

export default component.exports